/**
 * ABA分析列表数据Hook
 */
import { useState, useEffect, useMemo, useCallback } from 'react';
import { App } from 'antd';
import { skuAPI } from '../../../services/api';
import { SKU } from '../../../types/core-types';

export const useABAAnalysisList = () => {
    const { message } = App.useApp();
    const [skus, setSkus] = useState<SKU[]>([]);
    const [loading, setLoading] = useState(false);

    const loadSKUs = useCallback(async () => {
        setLoading(true);
        try {
            const response = await skuAPI.list();
            const data = response.data;
            if (Array.isArray(data)) {
                setSkus(data);
            } else if (data && typeof data === 'object' && 'results' in data) {
                setSkus((data as any).results || []);
            } else {
                setSkus([]);
            }
        } catch (error: any) {
            message.error('加载SKU列表失败');
        } finally {
            setLoading(false);
        }
    }, [message]);

    useEffect(() => {
        loadSKUs();
    }, [loadSKUs]);

    const stats = useMemo(() => {
        const total = skus.length;
        const hasData = skus.filter((sku) => sku.periods_count > 0).length;
        const noData = skus.filter((sku) => sku.periods_count === 0).length;
        const thisMonth = skus.filter((sku) => {
            const created = new Date(sku.created_at);
            const now = new Date();
            return created.getMonth() === now.getMonth() && created.getFullYear() === now.getFullYear();
        }).length;
        return { total, hasData, noData, thisMonth };
    }, [skus]);

    return { skus, loading, stats, reload: loadSKUs };
};
